module.exports = __webpack_public_path__ + "img/buy_none.a0c25757.png";